// extracted by mini-css-extract-plugin
export var header = "_bm-0";